"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : STICKY : STYLES --------------- ++++++++++ */


var _default = {
  sticky: {
    background: '#fff',
    // needed so elements passing behind this during scroll are hidden
    boxShadow: "0px -2px 4px 0px rgb(237, 241, 250)",
    marginTop: (0, _index.pxToEm)(150),
    // needed to prevent potential dropdowns not being able to fully display
    padding: (0, _index.replacePXinStringWithEM)("19px 0"),
    // force controls to bottom of the page always even when scrolling
    position: 'sticky',
    bottom: '0',
    left: '0',
    zIndex: '11',
    // above the top most section of this page
    opacity: '0',
    animationName: 'fadeInUp',
    animationDuration: '.2s',
    animationFillMode: 'forwards',
    animationDelay: '.4s'
  }
};
exports.default = _default;